import { render, staticRenderFns } from "./comp-admin.vue?vue&type=template&id=f02297e2&"
import script from "./comp-admin.vue?vue&type=script&lang=ts&"
export * from "./comp-admin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports